import firebase from "firebase";
// Your web app's Firebase configuration PRODUCTION
const g3ttimeConfig = {
  apiKey: "AIzaSyCLhbF_26vRuKES0F-1B6nT1EjaXJZScOY",
    authDomain: "g3ttime.firebaseapp.com",
    projectId: "g3ttime",
    storageBucket: "g3ttime.appspot.com",
    messagingSenderId: "535618140024",
    appId: "1:535618140024:web:cc05889b42ff872ed47a8d",
    measurementId: "G-841KQ9ZCP7"
};

// Your web app's Firebase configuration TEST
const g3ttimeTestConfig = {
  apiKey: "AIzaSyCLhbF_26vRuKES0F-1B6nT1EjaXJZScOY",
    authDomain: "g3ttime.firebaseapp.com",
    projectId: "g3ttime",
    storageBucket: "g3ttime.appspot.com",
    messagingSenderId: "535618140024",
    appId: "1:535618140024:web:cc05889b42ff872ed47a8d",
    measurementId: "G-841KQ9ZCP7"
};

// Initialize Firebase
//firebase.initializeApp(firebaseConfig);
// Initialize Firebase
const selectedProject = g3ttimeConfig;
const firebaseApp = firebase.initializeApp(selectedProject);
//firebase.analytics();

const URL_VAGIS = "https://us-central1-g3ttime.cloudfunctions.net/";
const URL_VAGIS_TEST = "";

//Key OneSignal
const KEY_MESSAGES_VAGIS = "7c674a51-61db-4da2-9cce-3f75c32e04a2";
const KEY_MESSAGES_VAGIS_TEST = "";

//Token OneSignal
const TOKEN_PUSH_VAGIS = "ODhkMDZmZGEtZWRkYS00ODlkLWJkNTYtZTk1Y2FjOTJjMjAw";
const TOKEN_PUSH_VAGIS_TEST = "";

//Templates OneSignal
//HUTS
const NUEVA_SOLICITUD_VAGIS = "f9eb417c-fde8-4cf1-a15a-19a3ed751e05";
const SOLICITUD_CANCELADA_VAGIS = "b39da1f7-8930-4a65-a1be-fbe7422c2b1b";
const SOLICITUD_MODIFICADA_VAGIS = "d9a15238-d2e9-42e5-80af-90068e6923d0";

//HUTS-TEST
const NUEVA_SOLICITUD_VAGIS_TEST = "";
const SOLICITUD_CANCELADA_VAGIS_TEST = "";
const SOLICITUD_MODIFICADA_VAGIS_TEST = "";

const STRIPE_PRODUCTION_PUBLIC_KEY = "pk_live_51HIhZsFspj3nfKi0m4dc3BGHOJx1gMcTmr0CIcO19KbmDJGY9R1boTWcnyq3ki6bdLSv0CNBlefXF56cL2OvV32Z00nE7WJ9HG"
const STRIPE_PRODUCTION_SECRET_KEY = "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"
const STRIPE_TEST_PUBLIC_KEY = "pk_test_51HIhZsFspj3nfKi0ecWuBpG4uEFYYbrzYDN08RgeJxERZoSHP2aijccsfNNCzEUP6tFw5Uq6d7Ouq0UFDfQW6NPJ00Pzaf6UDr"
const STRIPE_TEST_SECRET_KEY = "sk_test_51HIhZsFspj3nfKi06CFxjuMAMBFaHgTfQSAViHiBral1KJMLJ5XAhuWmU9T6BKQjWW2Kus3jlxfjTSazeDkfwkLB00is7ZbIlZ"

let URL_CLOUD_FUNCTIONS;
let KEY_MESSAGES;
let TOKEN_PUSH;
let NUEVA_SOLICITUD;
let SOLICITUD_CANCELADA;
let SOLICITUD_MODIFICADA;
let PROJECT_NAME;
let STRIPE_PUBLIC_KEY;
let STRIPE_SECRET_KEY;

if (selectedProject.projectId === "g3ttime") {
  URL_CLOUD_FUNCTIONS = URL_VAGIS;
  KEY_MESSAGES = KEY_MESSAGES_VAGIS;
  TOKEN_PUSH = TOKEN_PUSH_VAGIS;
  NUEVA_SOLICITUD = NUEVA_SOLICITUD_VAGIS;
  SOLICITUD_CANCELADA = SOLICITUD_CANCELADA_VAGIS;
  SOLICITUD_MODIFICADA = SOLICITUD_MODIFICADA_VAGIS;
  PROJECT_NAME = "G3TTIME";
  STRIPE_PUBLIC_KEY = STRIPE_TEST_PUBLIC_KEY//STRIPE_PRODUCTION_PUBLIC_KEY
  STRIPE_SECRET_KEY = STRIPE_TEST_SECRET_KEY//STRIPE_PRODUCTION_SECRET_KEY
} else if (selectedProject.projectId === "huts-test-39ce5") {
  URL_CLOUD_FUNCTIONS = URL_VAGIS_TEST;
  KEY_MESSAGES = KEY_MESSAGES_VAGIS_TEST;
  TOKEN_PUSH = TOKEN_PUSH_VAGIS_TEST;
  NUEVA_SOLICITUD = NUEVA_SOLICITUD_VAGIS_TEST;
  SOLICITUD_CANCELADA = SOLICITUD_CANCELADA_VAGIS_TEST;
  SOLICITUD_MODIFICADA = SOLICITUD_MODIFICADA_VAGIS_TEST;
  PROJECT_NAME = "VAGIS TEST";
  STRIPE_PUBLIC_KEY = ""
  STRIPE_SECRET_KEY = ""
}

const PROJECT_ID = selectedProject.projectId;
export {
  URL_CLOUD_FUNCTIONS,
  KEY_MESSAGES,
  TOKEN_PUSH,
  NUEVA_SOLICITUD,
  SOLICITUD_CANCELADA,
  SOLICITUD_MODIFICADA,
  PROJECT_NAME,
  PROJECT_ID,
  STRIPE_PUBLIC_KEY,
  STRIPE_SECRET_KEY
};
export default firebaseApp;
